module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "sample-text-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v(_vm._s(_vm.text.title))]), _vm._v(" "), _c('p', {
    staticClass: "sample-text text-color"
  }, [_vm._v("\n        " + _vm._s(_vm.text.content) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "div-card fadeIn animated"
  }, [_c('p', {
    staticClass: "sample-text text-color card"
  }, [_vm._v("\n                   " + _vm._s(_vm.text.pwertText) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "sample-text text-color card"
  }, [_vm._v("\n                  " + _vm._s(_vm.text.epmsText) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "whole-wrap warp-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "sample-text text-color"
  }, [_vm._v(_vm._s(_vm.text.taskText) + "\n      ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.details), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "container"
    }, [_c('div', {
      staticClass: "section-top-border fadeInLeft animated"
    }, [_c('h3', {
      staticClass: "mb-30 title_color"
    }, [_vm._v(_vm._s(v.left.title))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 mt-sm-20 left-align-p"
    }, [_c('p', [_vm._v(_vm._s(v.left.content))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-top-border text-right fadeInRight animated"
    }, [_c('h3', {
      staticClass: "mb-30 title_color"
    }, [_vm._v(_vm._s(v.right.title))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [_c('p', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(v.right.content))])]), _vm._v(" "), _vm._m(2, true)])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _c('br'), _vm._v("采用领域驱动设计(DDD)的软件开发设计方法，实现对用户业务需求进行微服务拆分。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 row-img"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 row-img"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/dr.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d04cb74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dtability.vue
// module id = 30
// module chunks = 0